(ns ballot-scout-v2-frontend.dashboard.views.fragments
  (:require
   [clojure.string :as str]))

(defn row [& sections]
  (apply vector :div sections))

(defn section [class-names & subsections]
  (apply vector :div {:class (str/join " " class-names)} subsections))

(defn title-section [& subsections]
  (row (apply vector :article.title-section subsections)))
